// @flow
import React, { type Node } from 'react';

import { createPortal } from 'react-dom';

import Flex from '@waglabs/flex';
import LoadingBoneSpinner from '@waglabs/loading-bone-spinner';

const ReactPortal = ({
  children,
}: {
  children: Node
 }) => {
  const root = document.getElementById('___gatsby');
  if (root) {
    createPortal(
      children,
      root,
    );
  }
  return children;
};

export const Spinner = () => (
  <ReactPortal>
    <Flex
      position="fixed"
      justifyContent="center"
      top="0"
      left="0"
      right="0"
      bottom="0"
      zIndex="10"
    >
      <LoadingBoneSpinner />
    </Flex>
  </ReactPortal>
);
